/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  SettingsCustomTagProtocolsCreateCustomTagRequest,
  SettingsCustomTagProtocolsCreateCustomTagResponse,
  SettingsCustomTagProtocolsDeleteCustomTagRequest,
  SettingsCustomTagProtocolsGetCustomTagsRequest,
  SettingsCustomTagProtocolsGetCustomTagsResponse,
  SettingsCustomTagProtocolsUpdateCustomTagRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CustomTag<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags CustomTag
   * @name CustomTagCreate
   * @request POST:/custom-tag
   */
  customTagCreate = (data: SettingsCustomTagProtocolsGetCustomTagsRequest, params: RequestParams = {}) =>
    this.http.request<SettingsCustomTagProtocolsGetCustomTagsResponse, any>({
      path: `/custom-tag`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomTag
   * @name CreateCreate
   * @request POST:/custom-tag/create
   */
  createCreate = (data: SettingsCustomTagProtocolsCreateCustomTagRequest, params: RequestParams = {}) =>
    this.http.request<SettingsCustomTagProtocolsCreateCustomTagResponse, any>({
      path: `/custom-tag/create`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomTag
   * @name UpdateCreate
   * @request POST:/custom-tag/update
   */
  updateCreate = (data: SettingsCustomTagProtocolsUpdateCustomTagRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/custom-tag/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags CustomTag
   * @name DeleteCreate
   * @request POST:/custom-tag/delete
   */
  deleteCreate = (data: SettingsCustomTagProtocolsDeleteCustomTagRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/custom-tag/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
